import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BillingAccountActions} from "../../services/billing-account-actions.service";
import {BillingAccountsRequests} from "../../services/billing-accounts-requests.service";
import {BillingAlertsService} from "../../services/billing-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

export class paymentMethodsCtrl implements IController {

  billingAccount: any;

  private processorLoading: any;
  private billingAccountCopy: any;
  private processor: any;

  /* @ngInject */
  constructor(private $billingAccounts, private billingAccountActions: BillingAccountActions, private confirmDialogService: ConfirmDialogService,
              private billingAccountsRequests: BillingAccountsRequests, private billingAlertsService: BillingAlertsService, private $log, private bringozLoaderService: BringozLoaderService) {
  }

  $onInit() {
    this.processorLoading = false;
    this.billingAccountCopy = this._getBillingAccountCopy(this.billingAccount);
  };

  addPaymentMethod(event) {
    this.processorLoading = true;
    this.billingAccountsRequests.getProcessor(this.billingAccount.id)
      .then((processor) => {
        this.processor = processor;
        // POS.setEnvironment(processor.osEnv);
        // POS.setPublicKey(processor.publicKey);
        this.processorLoading = false;
        return this.billingAccountActions.addPaymentMethod(event, this.billingAccount.id);
      })
      .then((payment) => {
        this.bringozLoaderService.on();
        return this.billingAccountsRequests.addPaymentMethod(this.billingAccount.id, payment.token)
      })
      .then((result) => {
        return this.billingAccountsRequests.getBillingAccount(this.billingAccount.id, true);
      })
      .then((billingAccount) => {
        this.billingAccount = billingAccount;
        this.billingAccountCopy = this._getBillingAccountCopy(this.billingAccount);
        this.billingAlertsService.addPaymentMethodSuccess();
      })
      .catch((error) => {
        if (error) {
          this.billingAlertsService.addPaymentMethodError();
          this.$log.error('Failed to add payment method @paymentMethods@addPaymentMethod', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.processorLoading = false;
        this.bringozLoaderService.off();
      })
  }

  onChangeDefaultPaymentMethod(paymentMethod) {
    if (paymentMethod.pmToken !== this.billingAccount.defaultPaymentMethod) {
      var billingAccountCopy = angular.copy(this.billingAccount);
      _.set(billingAccountCopy, 'defaultPaymentMethod', paymentMethod.pmToken);

      this.bringozLoaderService.on();
      this.$billingAccounts(this.billingAccount.id).$update(billingAccountCopy)
        .then((updatedBillingAccount) => {
          this.billingAccount = updatedBillingAccount;
          this.billingAlertsService.setDefaultPaymentMethodSuccess();
        })
        .catch((error) => {
          if (error) {
            this.billingAlertsService.setDefaultPaymentMethodError();
            this.$log.error(error.message);
          } else {
            this.$log.info('Dialog Closed')
          }
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    }
  }


  onRemovePaymentMethod(paymentMethod, event) {
    const title = this._getConfirmDialogTitle('Remove', paymentMethod.ccType, paymentMethod.ccLastDigits);
    this.confirmDialogService.confirm(title, 'Are you sure you want to remove the selected payment method?', event)
      .then(() => {
        this.bringozLoaderService.on();
        return this.billingAccountsRequests.removePaymentMethod(this.billingAccount.id, paymentMethod.pmToken);
      })
      .then((result) => {
        return this.billingAccountsRequests.getBillingAccount(this.billingAccount.id, true);
      })
      .then((billingAccount) => {
        this.billingAccount = billingAccount;
        this.billingAccountCopy = this._getBillingAccountCopy(this.billingAccount);
        this.billingAlertsService.removePaymentMethodSuccess();
      })
      .catch((error) => {
        if (error) {
          if (error.code === 'OPEN_DEBIT') {
            this.billingAlertsService.openDeptError();
          } else {
            this.billingAlertsService.removePaymentMethodError();
          }
          this.$log.error(error.message);
          return;
        }
        this.$log.info('Dialog Closed')
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }


  private _getBillingAccountCopy(billingAccount) {
    return angular.copy(billingAccount);
  }

  private _getConfirmDialogTitle(header, ccType, ccLastDigits) {
    return header + ': ' + ccType + ' ****-' + ccLastDigits;
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('paymentMethods', {
    bindings: {
      billingAccount: '<'
    },
    template: require('./payment-methods.html').default,
    controller: paymentMethodsCtrl
  });
